// extracted by mini-css-extract-plugin
export default {"container":"QK-z","error":"RK-z","disabled":"SK-z","submit":"TK-z","option":"UK-z","success":"VK-z","failure":"WK-z"};